import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import classes from './SalesSummary.css';
import Input from '../../../components/UI/Input/Input';


class SalesSummary extends Component {

    componentDidMount () {
        
    }

    render () {
            return (
                <div className={classes.SalesSummary}>
                    Hardwood: {this.props.summary.hardwoodBags}  Cedar: {this.props.summary.cedarBags}  Black: {this.props.summary.blackBags}  Red: {this.props.summary.redBags}  Total: {this.props.summary.totalBags}
                </div>
            )
    }
};

const mapStateToProps = state => {
 
    return {
        summary: state.orders.salesSummary
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetSalesSummary: (forUser ) => dispatch( actions.getSalesSummary(forUser) )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesSummary);


// WEBPACK FOOTER //
// ./src/components/Order/SalesSummary/SalesSummary.js